<template>
    <div class="n2-center-container" style="background-color:#fff; padding:10px;">
        <!--<div v-if="app_locale=='en'">
            <term-online-sale-en></term-online-sale-en>
        </div>
        <div v-else>
            <term-online-sale-no></term-online-sale-no>
        </div>-->
        <app-content name="web.term.online_payment"></app-content>

    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    //import TermOnlineSaleEn from '../components/app/text/term-online-sale.en.vue'
    //import TermOnlineSaleNo from '../components/app/text/term-online-sale.no.vue'
    import AppContent from '../components/shared/content.vue';

    export default {
        components: {
            AppContent
            //TermOnlineSaleEn,
            //TermOnlineSaleNo
        },
        computed: {
            ...mapGetters('globalization', [
                'app_locale',
                'locale',
            ])
        }
    }
</script>
